import { useEffect, useRef, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { FlaskConical, Loader2, CheckCircle2 } from "lucide-react";

export const LiveTransferZapTest = ({ onArrived }) => {
  const [ready, setReady] = useState(null);
  const [test, setTest] = useState(null);
  const [state, setState] = useState("");
  const timer = useRef(null);
  useEffect(() => {
    api.get("/live-transfers/test-zapier-ready").then((r) => setReady(r.data.connected)).catch(() => setReady(false));
    return () => { clearInterval(timer.current); };
  }, []);

  const send = async () => {
    setState("sending");
    try {
      const { data } = await api.post("/live-transfers/test-zapier");
      if (!data.accepted) { setState(""); toast.error(`Zapier answered HTTP ${data.status_code}`); return; }
      setTest(data); setState("waiting");
      let n = 0;
      clearInterval(timer.current);
      timer.current = setInterval(async () => {
        n += 1;
        const r = await api.get(`/live-transfers/test-zapier/${data.request_id}`).catch(() => null);
        if (r?.data.arrived) { clearInterval(timer.current); setState("arrived"); onArrived?.(); }
        else if (n >= 40) { clearInterval(timer.current); setState("timeout"); }
      }, 3000);
    } catch (e) { setState(""); toast.error(apiError(e)); }
  };

  const name = test ? `${test.sample.FirstName} ${test.sample.LastName}` : "";
  return (
    <Card className="mb-5 p-6" data-testid="lt-zap-test-card">
      <h3 className="mb-1 flex items-center gap-2 font-display font-bold text-slate-900"><FlaskConical className="h-4 w-4" /> Test caller details</h3>
      <p className="mb-3 text-sm text-slate-600">Sends a made-up caller (fake name, phone and address) through Zapier and back into Elite Leads. No call, no charge, no texts.</p>
      <Button onClick={send} disabled={!ready || state === "sending" || state === "waiting"} data-testid="lt-zap-test-btn">
        {state === "sending" || state === "waiting" ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : null}Send test data
      </Button>
      {ready === false && <p className="mt-2 text-sm text-slate-500" data-testid="lt-zap-test-status">The Zapier connection isn't set up yet - ask the admin.</p>}
      {state === "waiting" && <p className="mt-2 text-sm text-slate-600" data-testid="lt-zap-test-status">Sent {name} to Zapier. Waiting for it to come back...</p>}
      {state === "arrived" && <p className="mt-2 flex items-center gap-1.5 text-sm font-semibold text-emerald-700" data-testid="lt-zap-test-status"><CheckCircle2 className="h-4 w-4" />It worked - {name} arrived below.</p>}
      {state === "timeout" && <p className="mt-2 text-sm text-red-700" data-testid="lt-zap-test-status">Zapier received it, but nothing came back within 2 minutes. Check that the Zap is On.</p>}
    </Card>
  );
};
